import { useState } from '#imports'

export function useToggleSearchBar() {
  const isSearchBarActive = useState<boolean>('isSearchBarActive', () => false)

  const openSearchBar = () => {
    isSearchBarActive.value = true
  }

  const closeSearchBar = () => {
    isSearchBarActive.value = false
  }

  return {
    openSearchBar,
    closeSearchBar,
    isSearchBarActive,
  }
}
